import Slider from '../modules/slider';
import stories from '../modules/stories';

export default {
  init() {
    new Slider('.js-home-slider');
    stories.init();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHome.js